// extracted by mini-css-extract-plugin
export default {"container":"event_container__V5eSx","eventName":"event_eventName__d6+4c"};